module.exports = __webpack_public_path__ + "static/media/amansirright.1c9eedaa.png";